import { OrganisationPicker } from "@/app/Organisations/Components/OrganisationPicker";

export function OrganisationSelectScreen() {
  return (
    <div className="flex w-full max-w-md flex-col p-6">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900">
          Change Organization
        </h2>
        <p className="mt-1 text-sm text-gray-500">
          Choose an organization to continue or create a new one
        </p>
      </div>

      <OrganisationPicker />
    </div>
  );
}
